import "react-swipeable-list/dist/styles.css";
import dayjs from "dayjs";

type RelativeDateOutput = "gerade jetzt" | "gestern" | string;
type TemplateKey = "fulldate";

export default function getRelativeDate(
    date: Date | string,
    templates?: Record<TemplateKey, string>,
): RelativeDateOutput {
    const now = dayjs();
    const commentDate = dayjs(date);
    if (commentDate.isSame(now, "day")) {
        if (now.diff(commentDate, "minute") < 1) {
            return `gerade jetzt`;
        }
        if (now.diff(commentDate, "hour") < 1) {
            const diffMinutes = now.diff(commentDate, "minutes");
            return `vor ${diffMinutes} ${
                diffMinutes === 1 ? "Minute" : "Minuten"
            }`;
        }
        const diffHours = now.diff(commentDate, "hour");
        return `vor ${diffHours} ${diffHours === 1 ? "Stunde" : "Stunden"}`;
    }
    if (commentDate.isSame(now.subtract(1, "day"), "day")) {
        return "gestern";
    }

    const daysDiff = Math.ceil(now.diff(commentDate, "day", true));
    if (daysDiff < 31) {
        return `vor ${daysDiff} Tagen`;
    }

    const tpl = templates?.["fulldate"] ?? "{DATE}";

    return tpl.replace("{DATE}", commentDate.format("DD.MM.YYYY"));
}
